import { logoutType } from '@Constants/User';

import { createCombinedReducer } from '@Utils';

import { barChartFiltersReducer } from './BarChartFiltersReducer';
import { generalFiltersReducer } from './GeneralFiltersReducer';
import { thesaurusFiltersReducer } from './ThesaurusFiltersReducer';

import initialState from './initialState';

const reducers = [
  barChartFiltersReducer,
  generalFiltersReducer,
  thesaurusFiltersReducer,
];

const combinedReducer = createCombinedReducer(reducers);

export default function listOfFiltersReducer(state, action) {
  if (action.type === logoutType) {
    return initialState;
  }

  return combinedReducer(state, action);
}
